import React from 'react';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { Avatar, AvatarShapes, AvatarSizes, Text } from '@clockout-dev/design-elements';
import SectionCard from '../../common/sectionCard/SectionCard';
import UserCardRow from '../../users/user/elements/UserCardRow';
import SupportStatusPill from './SupportStatusPill';
import TicketLinkedLedger from './TicketLinkedLedger';
import { CATEGORY_OPTIONS, PRIORITY_OPTIONS } from '../support.enums';
import styles from '../styles/ticket-details-card.module.scss';

/**
 * Sidebar card showing ticket metadata on the detail page.
 *
 * @param {Object} props
 * @param {Object} props.ticket
 */
function TicketDetailsCard({ ticket }) {
    const openedDate = ticket.createdAt ? new Date(ticket.createdAt).toLocaleString() : '—';
    const creatorName = ticket.createdBy?.name || '—';
    const ledgers = ticket.ledgers || [];

    const getCategoryLabel = (categoryValue) => {
        if (!categoryValue) return '—';
        const option = CATEGORY_OPTIONS.find(opt => opt.value === categoryValue);
        return option ? option.label : categoryValue;
    };

    const getPriorityLabel = (priorityValue) => {
        if (!priorityValue) return '—';
        const option = PRIORITY_OPTIONS.find(opt => opt.value === priorityValue);
        return option ? option.label : priorityValue;
    };

    return (
        <SectionCard icon={<CustomerServiceOutlined />} title="Ticket details">
            <div className={styles.rows}>
                <UserCardRow label="Status" value={<SupportStatusPill status={ticket.status} />} />
                <UserCardRow label="Opened" value={openedDate} />
                <UserCardRow
                    label="Created by"
                    value={
                        <Avatar
                            name={creatorName}
                            size={AvatarSizes.SMALL}
                            shape={AvatarShapes.ROUNDED}
                            classNames={{
                                wrapper: styles.avatarWrapper,
                                root: styles.avatarRoot,
                            }}
                        />
                    }
                />
                {ticket.category ? (
                    <UserCardRow label="Category" value={getCategoryLabel(ticket.category)} />
                ) : null}
                {ticket.priority ? (
                    <UserCardRow label="Priority" value={getPriorityLabel(ticket.priority)} />
                ) : null}
                {ledgers.length > 0 ? (
                    <div className={styles.linkedTransactions}>
                        <Text as="span" size="s" className={styles.linkedTransactionsTitle}>
                            Linked transactions
                        </Text>
                        <div className={styles.linkedTransactionsList}>
                            {ledgers.map((ledger) => (
                                <TicketLinkedLedger key={ledger.id} ledger={ledger} />
                            ))}
                        </div>
                    </div>
                ) : null}
            </div>
        </SectionCard>
    );
}

export default TicketDetailsCard;
